import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useFeatureToggles } from '@grandvisionhq/state';
import { mapShippingMethods } from '../mappers/shipping-methods.js';
import '../operations/queries/get-delivery-estimation.js';
import '../operations/queries/get-estimated-delivery-by-skus.js';
import { GET_SHIPPING_METHODS_FOR_CART } from '../operations/queries/get-shipping-methods-for-cart.js';

const useGetShippingMethods = ({ onError , onCompleted  } = {})=>{
    const cartPriceRef = React.useRef(0);
    const { allowAlternativeShippingState  } = useFeatureToggles();
    const handleQueryError = React.useCallback((error)=>{
        console.error(`Fetch error: [query:shippingMethodsForCart] : `, error);
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'QUERY',
            error
        });
    }, [
        onError
    ]);
    const handleOnCompleted = React.useCallback((responseData)=>{
        if ('shippingMethodsForCart' in responseData) {
            const finalShippingMethods = mapShippingMethods(responseData.shippingMethodsForCart, cartPriceRef.current);
            onCompleted && onCompleted(finalShippingMethods);
        } else {
            onCompleted && onCompleted([]);
        }
    }, [
        onCompleted
    ]);
    const [getShippingMethodForCart, queryState] = useLazyQuery(GET_SHIPPING_METHODS_FOR_CART, {
        onError: handleQueryError,
        onCompleted: handleOnCompleted,
        fetchPolicy: 'no-cache'
    });
    const getShippingMethods = React.useCallback((cartId, cartPrice)=>{
        if (!cartId) {
            throw new Error('Need a cartId to load shipping methods.');
        }
        cartPriceRef.current = cartPrice;
        getShippingMethodForCart({
            variables: {
                checkoutId: cartId
            },
            fetchPolicy: allowAlternativeShippingState ? 'no-cache' : 'cache-first'
        });
    }, [
        allowAlternativeShippingState,
        getShippingMethodForCart
    ]);
    const queryResults = React.useMemo(()=>swcHelpers.objectSpread({}, queryState, {
            data: queryState.data ? mapShippingMethods(queryState.data.shippingMethodsForCart, cartPriceRef.current) : []
        })
    , [
        queryState
    ]);
    return [
        getShippingMethods,
        queryResults
    ];
};

export { useGetShippingMethods };
//# sourceMappingURL=use-get-shipping-methods.js.map
